import { all, takeLatest } from 'redux-saga/effects';
import env from 'config/environment';
import { SagaIterator } from 'redux-saga';
import * as ActionTypes from './actionTypes';

/**
 * This is exported and stored in an object for testing.
 */
const constants = {
  timeoutLength: env.SessionTimeout(),
  oneMinute: 60000,
};

// eslint-disable-next-line require-yield
export function* onUpdateApp(): SagaIterator {
  try {
    /** Put any actions that need to occur on Update App here.  Previously this included a call to renewSessionRequest,
     * but now user interaction determines how often renewing session request is made using event listeners.
    */
  } catch (errRef) {
    // you can catch errors here
  }
}

export default function* rootSaga() {
  yield all([takeLatest(ActionTypes.UPDATE_APP, onUpdateApp)]);
}

/**
 * Used for testing only.
 */
export const internalTesting = {
  constants,
};
